import { ImageFile } from "../shared/services"

export const MAX_FILE_MB = 5
// Mirrors the server's MAX_FRAMES (Converters::PixelsToWindowsCursor).
export const MAX_FRAMES = 30

// The file input's accept attribute: every readable type, then every extension.
export const ACCEPT = [
  ...new Set(Object.values(ImageFile.TYPES_BY_EXTENSION)),
  ...Object.keys(ImageFile.TYPES_BY_EXTENSION).map((extension) => `.${extension}`),
].join(",")
